export default __webpack_public_path__ + "static/photo-pass-0d2d622726f67f4d4280d9e3d08d7216.jpg";